import React from 'react'
import { Location, FormClock,Notes,FormSchedule,StatusCritical,FormClose,Alert } from 'grommet-icons';
import { Box, Button, FormField,TextInput,Form,DateInput,Text,Select,Layer } from 'grommet';
import {NavigationSnackBar, ReturnRowDir} from './utils/shared/shared'
import moment from 'moment'

function CreateCollectionForm(props){
    const onClose = () => {
        props.setError(false)
    }
    return (
        <Box>
             <NavigationSnackBar title={'Create Collection'} user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'}]}  />
            <Box align='center'>
            {props.error && (
                <Layer position="bottom" modal={false} margin={{ vertical: 'medium', horizontal: 'small' }} onEsc={onClose} responsive={false} plain>
                <Box align="center" direction="row" gap="small" justify="between" round="medium" elevation="large" pad={{ vertical: 'xsmall', horizontal: 'small' }} background="status-critical">
                    <Box align="center" direction="row" gap="xsmall">
                    <StatusCritical color='light-1'/>
                    <Text color='light-1' background='light-1'>
                      Tracking failed, please try again later. 
                    </Text>
                    </Box>
                    <Button icon={<FormClose color='light-1'/>} onClick={onClose} plain />
                    </Box>
                </Layer>
                )}
            <Form value={props.shipmentPickup} onSubmit={props.fetchShipment} onChange={nextValue => props.setShipmentPickup(nextValue)} validate='blur'>
                <Box background={'background-front'} justify='center' elevation='large' round margin='small' pad='small' >
                <Box direction={ReturnRowDir(props.size)}>
                    <FormField name="pickupDate" label={<Text size='xsmall'>Collection Date</Text>} required margin='small'>
                    <DateInput calendarProps={{daysOfWeek: true}} size='xsmall'firstDayOfWeek={1} name="pickupDate" format="dd/mm/yyyy" label="Collection Date"/>
                    </FormField>
                    <FormField name="pickupEarlyTime" label={<Text size='xsmall'>Collect From Time </Text>} required margin='small'> <TextInput name="pickupEarlyTime" type='time'  icon={<FormClock />}/> </FormField>
                    <FormField name="pickupCloseTime" label={<Text size='xsmall'>Closing Time</Text>} required margin='small'
                     validate={((pickupCloseTime, details) => {
                        var open = moment(details.pickupEarlyTime,'HH:mm:ss a')
                        var close = moment(pickupCloseTime,'HH:mm:ss a')
                        var duration = moment.duration(close.diff(open));
                        var hours = parseInt(duration.asHours());
                        if (hours <= 2){
                           return <Text size='xsmall' color={'status-critical'}>Minimum 2 hour interval required</Text>
                        }
                     })}> 
                     <TextInput name="pickupCloseTime" type='time'  icon={<FormClock />}/> 
                    </FormField>
                    <FormField name="awbNumber" label={<Text size='xsmall'>AWB Number of Shipment</Text>} required margin='small'> <TextInput icon={<Notes />}name="awbNumber" placeholder="Enter AWB Number of Shipment"/> </FormField>
                <FormField name="pickupLocation" label={<Text size='small'>Pickup Location</Text>}  required margin='small' info={<Text size='xsmall' color='text-xweak'>Where should your package be collected from?</Text>}>
                        <Select name="pickupLocation" icon={<Location />} placeholder="Pickup Location" options={['Front Desk', 'Reception', 'Warehouse', 'Office', 'Front Door']} />
                </FormField>
               </Box>
               <Box>
                 <Box style={{fontStyle: 'italic'}} justify='center' direction='row' margin={'small'}><Alert color='status-critical'/><Text weight={'bold'} size='xsmall' margin={{left:'xsmall', top:'xsmall'}}>Please ensure the shipper has the correct paperwork and the package(s) are ready for collection at the requested date and time. Failed collection attempts may be charged.</Text></Box>
               </Box>
                </Box> 
                    <Button margin='medium' primary label="Book Collection" type='submit' icon={<FormSchedule />}/>
                </Form> 
            </Box>
            </Box>
    )

}

export default CreateCollectionForm